import { WSAlert } from "@wingspanhq/fe-component-library";
import { BulkStatus } from "@wingspanhq/payments/dist/interfaces";
import { useQueryBulkPayrollBatches } from "../../../query/bulkPayrollBatch";

export function useHasProcessingBulkPayrollBatch() {
  const queryBulkPayrollBatches = useQueryBulkPayrollBatches({
    "filter[status][in]": [BulkStatus.Pending, BulkStatus.Processing]
  });

  return !!queryBulkPayrollBatches.data?.length;
}

export const AlertPayrollRunInProgress: React.FC = () => {
  const hasProcessingBulkPayrollBatch = useHasProcessingBulkPayrollBatch();

  if (!hasProcessingBulkPayrollBatch) {
    return null;
  }

  return (
    <WSAlert theme="info" title="A payroll run is already in progress">
      A payroll run is already in progress (scheduled or off-cycle). Once the
      progress is complete, a new off-cycle payroll run can be initiated.
    </WSAlert>
  );
};
